// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"Loading_loadingSpinner__Kp4US","loading":"Loading_loading__znO6D"};